;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('CustomizeFormatController', CustomizeFormatController)

  /* @ngInject */
  function CustomizeFormatController ($scope, $translate, $timeout, TagsService) {
    $scope.showAdvancedOptions = false
    $scope.selectedLang = 'PT-BR'

    $scope.bleedAreas = [{
      label: $translate.instant('noBleedArea'),
      value: null
    }, {
      label: '3mm',
      value: '3MM'
    }, {
      label: '5mm',
      value: '5MM'
    }, {
      label: '10mm',
      value: '10MM'
    }, {
      label: '30mm',
      value: '30MM'
    }, {
      label: '50mm',
      value: '50MM'
    }]

    $scope.languages = [
      { label: $translate.instant('portuguese'), value: 'PT-BR' },
      { label: $translate.instant('spanish'), value: 'ES-ES' },
      { label: $translate.instant('english'), value: 'EN-US' }
    ]

    const api = {
      _needsToScale,
      _calculateScaledMeasures,
      _handleOnChangeLanguage,
      _successGetCategories
    }

    this.getApi = () => api

    activate()

    function activate () {
      api._handleOnChangeLanguage($scope.selectedLang)

      TagsService.getTags().then(api._successGetCategories)
      $timeout(() => {
        $('.tooltip-hide-format-users').popup()
        $('.product-pages-label .tooltip-number-productpages').popup()
        $('.customize-format-form .language-dropdown').dropdown({
          onChange: api._handleOnChangeLanguage
        })
      }, 100, false)
    }

    const deregisterFormatCustomizeDefaultFormat = $scope.$on('format.customizeDefaultFormat', () => {
      api._handleOnChangeLanguage($scope.selectedLang)
    })

    $scope.$on('$destroy', () => {
      deregisterFormatCustomizeDefaultFormat()
    })

    $scope.shouldShowScaleInfo = function (form) {
      const shouldShow = api._needsToScale(form)
      $scope.form.product.isScaled = shouldShow

      return shouldShow
    }

    $scope.changeType = function (type) {
      $scope.form.product.type = type

      if (api._needsToScale($scope.form)) {
        api._calculateScaledMeasures($scope.form)
      } else {
        $scope.form.layers[0].scaledHeight = null
        $scope.form.layers[0].scaledWidth = null
      }
    }

    $scope.onMeasuresChange = function (model) {
      $scope.form.layers[0][model.modelPropertyName] = model.modelNewValue

      if ($scope.onChangeSize) {
        $scope.onChangeSize()
      }

      if (api._needsToScale($scope.form)) {
        api._calculateScaledMeasures($scope.form)
      }
    }

    $scope.onChangeRounded = function () {
      if ($scope.onChangeSize) {
        $scope.onChangeSize()
      }
    }

    $scope.showAdvancedOptionsClick = function () {
      $scope.showAdvancedOptions = !$scope.showAdvancedOptions
    }

    $scope.changeLanguageClick = function (selectedLang) {
      api._handleOnChangeLanguage(selectedLang)
    }

    $scope.onLastRepeatLanguageOption = function () {
      api._handleOnChangeLanguage($scope.selectedLang)
    }

    $scope.saveTitleOrDescription = function (field, title, description) {
      const textObject = $scope.form.texts.find(item => item.locale === $scope.selectedLang)

      if (field === 'title') {
        textObject.title = title
      } else {
        textObject.description = description
      }
    }

    function _needsToScale (form) {
      const layer = form.layers[0]
      const productType = form.product.type

      if (!layer.width || !layer.height) {
        return false
      }

      const shouldScale = productType === 'PRINTABLE' ? layer.width > 100 || layer.height > 100 : layer.width > 5000 || layer.height > 5000

      return shouldScale
    }

    function _calculateScaledMeasures (form) {
      const layer = form.layers[0]
      const productType = form.product.type
      const baseValue = productType === 'PRINTABLE' ? 100 : 5000
      let newHeight = 0
      let newWidth = 0

      if (layer.width > layer.height) {
        newWidth = baseValue
        newHeight = (layer.height * (newWidth / layer.width))
      } else {
        newHeight = baseValue
        newWidth = (layer.width * (newHeight / layer.height))
      }

      form.layers[0].scaledHeight = Number(newHeight.toFixed(2))
      form.layers[0].scaledWidth = Number(newWidth.toFixed(2))
    }

    function _handleOnChangeLanguage (value) {
      if (value && $scope.form) {
        const textObject = $scope.form.texts.find(item => item.locale === value)
        $scope.selectedLang = value

        if (textObject) {
          $scope.title = textObject.title
          $scope.description = textObject.description
        }

        $timeout(() => {
          $('.input-format-title input').val($scope.title)
          $('input-text-area textarea').val($scope.description)
        }, 100, false)
      }
    }

    function _successGetCategories (res) {
      $scope.tags = res.rows.map(category => {
        return { value: category.id, label: category.name }
      })
    }
  }
})()
